import { resizeImage } from "easy-image-resizer";

import type { File } from "easy-db-node";

type Content = {
    content: string,
    files: File[],
}
export async function handleContentFiles(source: Content, element: HTMLDivElement): Promise<Content> {
    let content = source.content;
    const files: File[] = [];

    const images = element.querySelectorAll("img");

    const srcs: string[] = [];
    images.forEach((img, i) => srcs[i] = img.getAttribute("src") || "");

    for (let i = 0; i < images.length; i++) {
        const src = srcs[i];

        if (src.startsWith("data:image/")) {
            const img = images[i];
            const { width, height } = img.getBoundingClientRect();
            const base64 = await resizeImage(src, {
                maxWidth: width,
                maxHeight: height,
                type: "webp",
            });

            content = content.replace(src, `__TSOKRKONOSE_${i}__`);

            files[i] = {
                type: "EASY_DB_FILE",
                url: base64,
            };
        } else {
            const file = source.files.find(f => f?.url === src);
            if (file) {
                files[i] = file;
            }
            // not hosted images are not added to files
        }
    }

    return { content, files };
}